export class NetMessageCodec {
  private readonly littleEndian: boolean = true;
  private readonly headerLength: number = 19;

  constructor(littleEndian?: boolean | undefined) {
    if (littleEndian !== undefined) {
      this.littleEndian = littleEndian;
    }
  }

  public encode(
    main: number,
    sub: number,
    payload?: any | undefined
  ): Uint8Array {
    let dataSize = this.headerLength;
    const nFlag = 0; // nFlag 字段为 0
    const nRoomNumber = 0; // nRoomNumber 字段为 0
    const nUserID = 0; // nUserID 字段为 0
    const nLinkPort = BigInt(0); // nLinkPort 字段为 0

    if (payload !== undefined) {
      dataSize += payload.byteLength;
    }

    const buff = new Uint8Array(dataSize);
    const dv = new DataView(buff.buffer);
    // 设置头部信息
    dv.setUint8(0, nFlag); // nFlag: 1 byte
    dv.setUint16(1, main, this.littleEndian); // nMainCmdID: 2 bytes
    dv.setUint16(3, sub, this.littleEndian); // nSubCmdID: 2 bytes
    dv.setUint16(5, nRoomNumber, this.littleEndian); // nRoomNumber: 2 bytes
    dv.setUint32(7, nUserID, this.littleEndian); // nUserID: 4 bytes
    dv.setBigInt64(11, nLinkPort, this.littleEndian); // nLinkPort: 8 bytes

    if (payload !== undefined) {
      buff.set(payload, this.headerLength);
    }

    return buff;
  }

  public decode(data: any): any | undefined {
    if (data.byteLength < this.headerLength) {
      console.log("unpack data size error", data.byteLength);
      return undefined;
    }
    const dv = new DataView(data);
    // 读取头部信息
    const _nFlag = dv.getUint8(0); // nFlag: 1 byte (ignored)
    const mainCmdID = dv.getUint16(1, this.littleEndian); // nMainCmdID: 2 bytes
    const subCmdID = dv.getUint16(3, this.littleEndian); // nSubCmdID: 2 bytes
    const _nRoomNumber = dv.getUint16(5, this.littleEndian); // nRoomNumber: 2 bytes (ignored)
    const _nUserID = dv.getUint32(7, this.littleEndian); // nUserID: 4 bytes (ignored)
    const _nLinkPort = dv.getBigInt64(11, this.littleEndian); // nLinkPort: 8 bytes (ignored)
    //console.log(_nFlag, _nRoomNumber, _nUserID, _nLinkPort);

    const payloadByteLength = data.byteLength - this.headerLength;
    let payload: any;
    if (payloadByteLength > 0) {
      payload = data.slice(this.headerLength);
    }

    const dataSize = dv.getUint16(0, this.littleEndian);
    if (dataSize < this.headerLength) {
      console.log("unpack data size error", dataSize);
      return undefined;
    }

    //console.log(main, sub, payload);

    return {
      main: mainCmdID,
      sub: subCmdID,
      payload: payload,
    };
  }
}
